import React, { Dispatch, FC, SetStateAction, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSWRConfig } from 'swr';
import createTenant from '../../api/tenant/createTenant';
import { TenantContext } from '../../contexts/tenantContext';
import AddTenantModal from '../Modals/AddTenantModal/addTenantModal';
import { ActionButtonOnBoardingStyled } from '../OnBoarding/styled';

interface AddTenantActionProps {
    openCreateTenantModal: boolean;
    setOpenCreateTenantModal: Dispatch<SetStateAction<boolean>>;
}

const AddTenantAction: FC<AddTenantActionProps> = ({ setOpenCreateTenantModal, openCreateTenantModal }) => {
    const { t } = useTranslation('settings');
    const { mutate } = useSWRConfig();
    const [selectedSchema] = useContext(TenantContext) ?? [];

    const mutateTenant = () => {
        mutate(`${process.env.REACT_APP_API_URL}/tenant`);
    };
    const creationTenant = async (name: string) => {
        const slug = name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9-]/g, '');
        const newTenant = await createTenant(name, slug, false, t('tenants.modal.successMessage', { tenantName: name }), t('tenants.modal.errorMessage', { tenantName: name }), mutateTenant, selectedSchema || '');
        if (newTenant) {
            mutateTenant();
            setOpenCreateTenantModal(false);
        }
    };

    return (
        <>
            <ActionButtonOnBoardingStyled onClick={() => setOpenCreateTenantModal(true)} default disableRipple>
                {t('tenants.addNewTenant')}
            </ActionButtonOnBoardingStyled>

            {openCreateTenantModal && (
                <AddTenantModal
                    handleClose={() => setOpenCreateTenantModal(false)}
                    labelButton={t('tenants.createTenantButton')}
                    labelInput={t('tenants.modal.addNewTenantInputTitle')}
                    openModal={openCreateTenantModal}
                    placeholder={t('tenants.modal.placeholder')}
                    sendValue={creationTenant}
                    title={t('tenants.modal.createTenantTitle')}
                />
            )}
        </>
    );
};

export default AddTenantAction;
